import React from 'react';
import { Link } from 'react-router-dom';
const Music = () => {
  return (
    <div className="min-h-screen px-4 py-12 bg-gradient-to-br from-yellow-100 via-pink-50 to-red-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition duration-300">
      <div className="max-w-5xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row items-center">

        {/* Image Section */}
        <div className="md:w-1/2 flex justify-center items-center p-4">
          <img
            src="https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fG11c2ljfGVufDB8fDB8fHww"
            alt="Music Class"
            className="w-full max-w-sm h-auto rounded-lg object-cover shadow-md"
          />
        </div>

        {/* Content Section */}
        <div className="md:w-1/2 p-4 md:p-6 flex flex-col justify-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4">
            🎵 Music Teacher
          </h1>
          <p className="text-base text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
            Music enhances creativity, discipline, and emotional well-being. Our trained music educators introduce your child to the joy of rhythm, melody, and expression in an interactive and enjoyable way.
          </p>

          {/* Available Options */}
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-4">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">🎼 Available Options:</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>🎤 Vocal (Classical / Light)</li>
              <li>🎸 Instruments: Keyboard, Guitar, Tabla, etc.</li>
              <li>📘 Music theory and fun rhythm activities</li>
            </ul>
          </div>

          {/* Why Choose Us */}
          <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 shadow-inner mb-6">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">🌟 Why Choose Our Music Program?</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-200 text-sm">
              <li>👩‍🏫 Certified and experienced music teachers</li>
              <li>🎶 Personalized training for vocals and instruments</li>
              <li>🧒 Kid-friendly sessions that build confidence</li>
              <li>🏠 Both home and online music classes available</li>
              <li>📅 Flexible batch timings (evening & weekend)</li>
              <li>📈 Monthly student performance showcases</li>
              <li>🏆 Opportunity to participate in competitions & recitals</li>
              <li>🎓 Beginner to advanced level training paths</li>
            </ul>
          </div>
          <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
            <Link to="/contact">
              <button className="bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto">
                Book a Free Music Demo Class
              </button>
            </Link>
            <a
              href="https://wa.me/919999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto text-center"
            >
              📲 Connect on WhatsApp
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Music;
